// extracted by mini-css-extract-plugin
export var brand = "_7z-8";
export var compact = "_7z-5";
export var extraSmall = "_7z-6";
export var icon = "_7z-0";
export var large = "_7z-3";
export var light = "_7z-1";
export var medium = "_7z-4";
export var outline = "_7z-a";
export var primaryDark = "_7z-9";
export var primaryLight = "_7z-7";
export var primaryModern = "_7z-b";
export var success = "_7z-2";